import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import flatpickr from 'flatpickr';

const allRooms = [
  {
    img: '/images/resource/room-service1-1.jpg',
    title: 'China',
    price: 150,
    persons: '1-2',
    bed: 'King Size Bed',
    type: 'suite',
  },
  {
    img: '/images/resource/room-service1-2.jpg',
    title: 'Canada',
    price: 250,
    persons: '1-4',
    bed: 'Queen Bed',
    type: 'suite',
  },
  {
    img: '/images/resource/room-service1-3.jpg',
    title: 'UK',
    price: 550,
    persons: '1-2',
    bed: 'King Size Bed',
    type: 'suite',
  },
  {
    img: '/images/resource/room-service1-1.jpg',
    title: 'Standard Room',
    price: 80,
    persons: '1-2',
    bed: 'Single Bed',
    type: 'standard',
  },
  {
    img: '/images/resource/room-service1-2.jpg',
    title: 'Deluxe Room',
    price: 120,
    persons: '1-2',
    bed: 'Double Bed',
    type: 'deluxe',
  },
];

export default function RoomsSearch() {
  const [query, setQuery] = useState('');
  const [filtered, setFiltered] = useState(allRooms);
  const [maxPrice, setMaxPrice] = useState(1000);
  const checkInRef = useRef(null),
    checkOutRef = useRef(null);

  useEffect(() => {
    const fpIn = flatpickr(checkInRef.current, { dateFormat: 'Y-m-d' });
    const fpOut = flatpickr(checkOutRef.current, { dateFormat: 'Y-m-d' });
    return () => {
      fpIn.destroy();
      fpOut.destroy();
    };
  }, []);

  const search = () => {
    setFiltered(
      allRooms.filter(
        (r) =>
          r.price <= maxPrice &&
          (query === '' || r.title.toLowerCase().includes(query.toLowerCase())),
      ),
    );
  };

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle
        title="Room Search Results"
        breadcrumbs={[{ label: 'Rooms', path: '/rooms' }, { label: 'Search' }]}
      />

      <section className="pt-80 pb-40">
        <div className="auto-container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3">
              <div
                className="sidebar-widget p-4"
                style={{ background: '#f8f9fa', borderRadius: 8 }}
              >
                <h5 className="mb-3">Search Filters</h5>
                <div className="mb-3">
                  <label className="form-label">Room Name</label>
                  <input
                    className="form-control"
                    placeholder="Search rooms..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Check In</label>
                  <input
                    ref={checkInRef}
                    className="form-control date-pick"
                    placeholder="Select date"
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Check Out</label>
                  <input
                    ref={checkOutRef}
                    className="form-control date-pick"
                    placeholder="Select date"
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Max Price: ${maxPrice}</label>
                  <input
                    type="range"
                    className="form-range"
                    min="80"
                    max="1000"
                    value={maxPrice}
                    onChange={(e) => setMaxPrice(+e.target.value)}
                  />
                </div>
                <button
                  className="theme-btn btn-style-one w-100"
                  onClick={search}
                >
                  <span className="btn-title">Search</span>
                </button>
              </div>
            </div>

            {/* Results */}
            <div className="col-lg-9">
              <div className="row">
                {filtered.length === 0 ? (
                  <div className="col-12">
                    <p className="text-center py-5">
                      No rooms match your criteria.
                    </p>
                  </div>
                ) : (
                  filtered.map((r, i) => (
                    <div
                      key={i}
                      className="room-service-block-one col-lg-6 mb-4"
                    >
                      <div className="inner-box">
                        <div className="image-box">
                          <figure className="image mb-0">
                            <Link to="/room-details">
                              <img src={r.img} alt={r.title} />
                            </Link>
                          </figure>
                        </div>
                        <div className="content-box">
                          <div className="inner-box">
                            <h4 className="title">
                              <Link to="/room-details">{r.title}</Link>
                            </h4>
                            <div className="price">${r.price}/ Night</div>
                          </div>
                          <div className="facilities-box align-items-center d-flex justify-content-between">
                            <ul className="facilities-list">
                              <li>
                                <i className="fal fa-circle-user me-2"></i>{' '}
                                {r.persons} Persons
                              </li>
                              <li>
                                <i className="fal fa-bed me-2"></i> {r.bed}
                              </li>
                            </ul>
                            <ul className="facilities-list">
                              <li>
                                <i className="fal fa-bath me-2"></i> Bathtub
                              </li>
                              <li>
                                <i className="fal fa-wifi me-2"></i> Free Wifi
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
